import invariant from 'invariant';
import Cesium from 'cesium';

const BING_API_URL = process.env.BING_API_URL;
const BING_API_KEY = process.env.BING_API_KEY;

invariant(BING_API_KEY && BING_API_URL, 'missing bing credentials');

// Convert from placename query -> (lat, lon).
export function forwardGeocode(query) {
  return async (dispatch) => {
    const response = await requestResource(`Locations`, {
      query,
      maxResults: 1,
    });
    return parseLocationResponse(response);
  };
}

// Convert from (lat, lon) query -> placename.
export function reverseGeocode(lat, lon) {
  return async (dispatch) => {
    const response = await requestResource(`Locations/${lat},${lon}`, {
      includeEntityTypes: "PopulatedPlace,AdminDivision1,AdminDivision2,CountryRegion",
    });
    return parseLocationResponse(response);
  };
}

function requestResource(resource, params = {}) {
  const url = `${BING_API_URL}/${resource}`;
  return Cesium.loadJsonp(url, {
    parameters: {
      key: BING_API_KEY,
      ...params,
    },
    callbackParameterName : 'jsonp',
  });
}

function parseLocationResponse(response) {
  if (response.resourceSets.length === 0) {
      return [];
  }

  const resources = response.resourceSets[0].resources;
  return resources.map(resource => {
    // Convert to radians for our internal representation.
    // Also swap from (lat, lon) to (lon, lat).
    const [lat, lon] = resource.point.coordinates.map(degrees => degrees * (Math.PI / 180.0));
    return {
        displayName: resource.name,
        coordinates: [lon, lat],
    };
  });
}



// WEBPACK FOOTER //
// ./src/actions/geocoder.js